import { FlaskConical, Gavel, LineChart, type LucideIcon } from 'lucide-react';
import { env } from '@/lib/env';

export interface ModerationToolLink {
  label: string;
  url: string;
  icon: LucideIcon;
}

/** Policy-tool deep links from build-time env (CMP parity: BuildKonfig.coopUrl / ospreyUrl). */
export function configuredModerationToolLinks(): ModerationToolLink[] {
  return [
    env.VITE_COOP_URL
      ? { label: 'Coop Policy Console', url: env.VITE_COOP_URL, icon: Gavel }
      : null,
    env.VITE_OSPREY_URL
      ? { label: 'Osprey Rules', url: env.VITE_OSPREY_URL, icon: LineChart }
      : null,
    env.VITE_COOP_URL
      ? { label: 'Testing Harness', url: `${env.VITE_COOP_URL}/dev/moderation-harness`, icon: FlaskConical }
      : null,
  ].filter((link): link is ModerationToolLink => link !== null);
}

/**
 * Coop Investigation deep link for a TipMi case/item id.
 * Prefers VITE_COOP_URL (env-correct host); falls back to an API-provided URL when present.
 */
export function coopInvestigationUrl(
  caseId: string | null | undefined,
  apiCoopUrl?: string | null,
): string | null {
  const id = caseId?.trim();
  const base = env.VITE_COOP_URL.replace(/\/$/, '');
  if (base && id) {
    return `${base}/dashboard/manual_review/investigation?id=${encodeURIComponent(id)}`;
  }
  const fromApi = apiCoopUrl?.trim();
  return fromApi || null;
}

export function openExternalUrl(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
